module.exports = __webpack_public_path__ + "img/hardware8.96319ee9.png";